import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ContractService } from "../../../../../auth/service/contract.service";
import { ManageBargainingContractService } from "../../../../../auth/service/manage-bargaining-contract.service";
import { JobSiteService } from "../../../../../auth/service/job-sites.service";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { AuthenticationService } from "../../../../../auth/service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment/moment";
import { locale as italian } from "../../../../../i18n/it";
import { TransformationService } from "../../../transformation.service";
import { CollaboratorsService } from "../../../collaborators.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-edit-transformation",
  templateUrl: "./edit-transformation.component.html",
  styleUrls: ["./edit-transformation.component.scss"],
})
export class EditTransformationComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();

  @ViewChild("noteModal") noteModal: ElementRef;
  @ViewChild("noteDisableTransformation") noteDisableTransformation: ElementRef;

  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public currentTransformation: any;
  public transformationCandidate: any = {};
  public idTransformation: number;
  public today_date: string;
  public status_note: string = "";
  public contractList: any = [];
  public reject_type: string = "";
  public activeTab: string;
  public contractPreviewViewed: boolean = false;
  public candidateBecameEmployee: boolean = false;
  public disableNote: string = "";

  public statusDocument: any = [
    {
      label: "NOT_SENDED_PLURAL",
      color: "secondary",
    },
    {
      label: "SENDED_PLURAL",
      color: "info",
    },
    {
      label: "TO_APPROVED",
      color: "warning",
    },
    {
      label: "APPROVED_MALE_PLURAL",
      color: "success",
    },
    {
      label: "NOT_APPROVED_PLURAL_MALE",
      color: "danger",
    },
  ];

  public statusContract: any = [
    {
      label: "NOT_SENDED",
      color: "secondary",
    },
    {
      label: "SENDED",
      color: "info",
    },
    {
      label: "TO_APPROVED",
      color: "warning",
    },
    {
      label: "APPROVED",
      color: "success",
    },
    {
      label: "NOT_APPROVED",
      color: "danger",
    },
  ];

  constructor(
    public _contractService: ContractService,
    public _contractManager: ManageBargainingContractService,
    public _jobSiteService: JobSiteService,
    private _changeDetectorRef: ChangeDetectorRef,
    public _citiesService: CitiesService,
    public _authenticationService: AuthenticationService,
    private _activatedRoute: ActivatedRoute,
    public _userFigureService: UserFigureService,
    public _transformationService: TransformationService,
    public _utilService: UtilsService,
    private _router: Router,
    public _modalService: NgbModal,
    public _collaboratorsService: CollaboratorsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      this.idTransformation = Number(params.get("id"));
    });
    this.today_date = moment().format("YYYY-MM-DD");
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      this._utilService.hideLoading();
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this._contractService.getList();
    this.contractList = this._contractService.list;
    //Escludo dai contratti stage e disoccupato che per le trasformazioni non ci occorrono(i collaboratori sono già stagisti)
    this.contractList = this.contractList.filter((contract) => contract.name !== "Stage" && contract.name !== "Disoccupato");
    await this.loadTransformation();
  }

  ngOnDestroy() {
    this._contractManager.resetData();
  }

  async loadTransformation() {
    this.currentTransformation = await this._transformationService
      .getSingleTransformation(this.idTransformation)
      .then((result: any) => {
        if (result.status !== 2) {
        }
        return result;
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_NOT_FOUND_TRANSFORMATION" });
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      });
    if (!this.currentTransformation) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_NOT_FOUND_TRANSFORMATION" });
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.currentTransformation) {
      this.contentHeader = {
        headerTitle: italian.data.EDIT_TRANSFORMATION + " " + italian.data.FOR + " " + this.currentTransformation.user.firstname + " " + this.currentTransformation.user.lastname,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: "MENU.TRANSFORMATION",
              isLink: true,
              link: "/dashboard/transformation-list",
            },
            {
              name: italian.data.EDIT_TRANSFORMATION + " " + italian.data.FOR + " " + this.currentTransformation.user.firstname + " " + this.currentTransformation.user.lastname,
              isLink: false,
            },
          ],
        },
      };
    }

    this.transformationCandidate = await this._collaboratorsService.getCollaborator(this.currentTransformation.user.hash);
    if (this.transformationCandidate && this.transformationCandidate.addresses && this.transformationCandidate.addresses.length > 1) {
      this.transformationCandidate.addresses = this.transformationCandidate.addresses.filter((address: any) => address.label === "residenza");
    }
    if (Object.keys(this.currentTransformation).length > 0) {
      await this._contractManager.init(this.currentTransformation);
      this._contractManager.data.role = this.currentTransformation.role_id;
    } else {
      await this._contractManager.init();
    }

    this._contractManager.data.record_type = "desiderata";
    if (this.currentTransformation && this.currentTransformation.user.birthday) {
      this.currentTransformation.apprenticeship = moment().diff(this.currentTransformation.user.birthday, "years");
    }

    const statusDocument: number = this.currentTransformation.transformation_document.status;
    const statusContract: number = this.currentTransformation.transformation_contract.status;

    this.currentTransformation.timeline_status = statusContract + statusDocument;

    if (statusDocument === 3 && statusContract >= 0) {
      this.currentTransformation.timeline_status -= 1;
    }

    if (this.currentTransformation.status === 2) {
      this.currentTransformation.timeline_status = 6;
    }

    if (statusDocument === 4) {
      this.currentTransformation.timeline_status = 1;
    }

    if (statusContract === 4) {
      this.currentTransformation.timeline_status = 3;
    }

    //Controllo che la contrattazione sia completata e che il candidato sia diventato effettivamente dipendente
    if (this.currentTransformation.timeline_status === 5 && moment() >= moment(this.currentTransformation.start_date)) {
      this.candidateBecameEmployee = true;
    }
    this._utilService.hideLoading();
    this._changeDetectorRef.detectChanges();
  }

  fieldHasErrors(field_name: string): boolean {
    return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
  }

  async drop(event) {
    const nextStep: number = Number(event.container.element.nativeElement.id.replace("step", ""));
    const currentStep: number = Number(this.currentTransformation.timeline_status);
    const availableSteps = [
      [1, 6], // contrattazione --> if(currentStep === 0 && nextStep !== 1 && nextStep !== 6) return false
      [6], // richiedi dati anagrafici --> if(currentStep === 1 && nextStep !== 1) return false
      [1, 3, 6], // approva dati anagrafici --> if(currentStep === 2 && nextStep !== 1 && nextStep !== 3 && nextStep !== 6) return false
      [6], // invia contratto --> if(currentStep === 3 && nextStep !== 6) return false
      [3, 5, 6], // contratto da approvare --> if(currentStep === 4 && nextStep !== 3 && nextStep !== 5 && nextStep !== 6) return false
      [6], // completa --> if(currentStep === 5 && nextStep !== 6) return false
      [1, 3, 5], // annullata
    ];

    // se sono al primo step posso solo andare allo step successivo
    if (!availableSteps[currentStep].includes(nextStep)) {
      return false;
    }

    // aggiorno ora lo stato
    this.currentTransformation.timeline_status = nextStep;

    // se sono in contratto da approvare posso andare solo in
    switch (nextStep) {
      case 1: // richiedi dati anagrafici
        if (currentStep === 0) {
          await this.requestDocumentMasterData();
        } else {
          await this.openModal(this.noteModal, "document", "md");
        }
        this.currentTransformation.transformation_document.status = 1;
        break;
      case 3:
        if (currentStep === 2) {
          //Mostro un messaggio di avviso visualizzazione anteprima contratto
          let confirmationText: string = `${await this._utilService.translate("ALERT.CONFIRM_VIEW_PREVIEW_CONTRACT")}`;
          await this._utilService
            .showSWALDecision({
              text: confirmationText,
              confirmButtonText: "CONFIRM_VIEWED_CONTRACT_BTN",
            })
            .then(async (result) => {
              if (result.value) {
                //Vado avanti
                await this.approveDocument("document").then(() => this.requestDocumentContract());
              } else if (result.isDismissed) {
                //Resetto nel caso abbia cliccato annulla
                this.currentTransformation.timeline_status = currentStep;
                return false;
              }
            });
        } else {
          await this.openModal(this.noteModal, "contract", "md");
        }
        this.currentTransformation.transformation_contract.status = 1;
        break;
      case 5:
        await this.approveDocument("contract");
        break;
      case 6:
        this.openModal(this.noteDisableTransformation, "disable", "sm");
        break;
    }
  }

  isDisabledSave() {
    if (this._contractManager.typeIsStage) {
      //Controllo in caso di contratto a stage
      if (
        this._contractManager.data.role === "" ||
        this._contractManager.data.contract < 1 ||
        Number(this._contractManager.data.net_monthly_12) < 1 ||
        this._contractManager.data.start_date === "" ||
        Number(this._contractManager.data.total_daily) < 1 ||
        !this._contractManager.data.tutor_hash ||
        !this._contractManager.data.end_date
      ) {
        return true;
      }
      return false;
    }
    if (
      this._contractManager.data.level === "" ||
      this._contractManager.data.role === null ||
      this._contractManager.data.contract === null ||
      (this._contractManager.data.gross_monthly_12 && this._utilService.removeDotsFromNumber(this._contractManager.data.gross_monthly_12) < 1) ||
      this._contractManager.data.trial === "" ||
      (this._contractManager.data.net_monthly_12 && this._utilService.removeDotsFromNumber(this._contractManager.data.net_monthly_12) < 1) ||
      (this._contractManager.data.net_monthly_13 && this._utilService.removeDotsFromNumber(this._contractManager.data.net_monthly_13) < 1) ||
      (this._contractManager.data.total_net_monthly_13 && this._utilService.removeDotsFromNumber(this._contractManager.data.total_net_monthly_13) < 1) ||
      (this._contractManager.data.salary_yearly_gross && this._utilService.removeDotsFromNumber(this._contractManager.data.salary_yearly_gross) < 1) ||
      (this._contractManager.data.total_daily && this._utilService.removeDotsFromNumber(this._contractManager.data.total_daily) < 1) ||
      this._contractManager.data.start_date === null
    ) {
      return true;
    }
    if (this._contractManager.data.contract === 3 && !this._contractManager.data.tutor_hash) {
      return true;
    }
    if (this._contractManager.data.contract !== 1 && !this._contractManager.data.end_date) {
      return true;
    }
    return false;
  }

  openModal(modal, type: string, modalSize: string) {
    this._modalService.open(modal, {
      centered: true,
      size: modalSize,
      backdrop: false,
      keyboard: false,
    });
    this.reject_type = type;
  }

  modalClose(isActionBack: boolean = false) {
    //Nel caso nella modale l'utente ha cliccato indietro riporto lo step a quello precedente
    if (isActionBack) {
      if (this.reject_type === "document") {
        this.currentTransformation.timeline_status = 1;
      }
      if (this.reject_type === "contract") {
        this.currentTransformation.timeline_status = 4;
      }
      if (this.reject_type === "disable") {
        const statusDocument: number = this.currentTransformation.transformation_document.status;
        const statusContract: number = this.currentTransformation.transformation_contract.status;
        this.currentTransformation.timeline_status = statusContract + statusDocument;
      }
    }

    this._modalService.dismissAll();
    this.status_note = "";
    this.reject_type = "";
    this.callbackFn.emit();
  }

  async requestDocumentMasterData() {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._transformationService
      .request_masterdata_collaborator(this.currentTransformation.user.hash)
      .then(async () => {
        this._utilService.hideLoading();
        this.currentTransformation.status_document = 1;
        await this._utilService.showSWALSuccess({ text: "MASTERDATA_SENDED" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "MASTERDATA_SENDED_ERROR" });
      });
  }

  async requestDocumentContract() {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this.previewContract(false).then(async () => {
      await this._transformationService
        .request_sign_contract_collaborator(this.currentTransformation.user.hash)
        .then(async () => {
          this._utilService.hideLoading();
          this.currentTransformation.status_contract = 1;
          await this._utilService.showSWALSuccess({ text: "SUCCESS_REQUEST_CONTRACT_DOCUMENT" });
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_REQUEST_CONTRACT_DOCUMENT" });
        });
    });
  }

  async approveDocument(type: string) {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    let data = {
      status: 3,
      type: type,
    };
    this._utilService.showLoading();
    await this._transformationService
      .updateDocumentStatus(Number(this.idTransformation), data)
      .then(async () => {
        this._utilService.hideLoading();
        type === "document" ? (this.currentTransformation.status_document = 3) : (this.currentTransformation.status_contract = 3);
        await this._utilService.showSWALSuccess({ text: "SUCCESS_APPROVED_DOCUMENT" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_APPROVED_DOCUMENT" });
      });
  }

  async rejectDocument() {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    let data = {
      status: 4,
      type: this.reject_type,
      status_note: this.status_note,
    };
    this.modalClose();
    this._utilService.showLoading();
    await this._transformationService
      .updateDocumentStatus(Number(this.idTransformation), data)
      .then(async () => {
        this._utilService.hideLoading();
        data.type === "document" ? (this.currentTransformation.status_document = 4) : (this.currentTransformation.status_contract = 4);
        data.type === "document" ? (this.currentTransformation.transformation_document.status_note = data.status_note) : (this.currentTransformation.transformation_contract.status_note = data.status_note);
        await this._utilService.showSWALSuccess({ text: "SUCCESS_REJECT_DOCUMENT" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_REJECT_DOCUMENT" });
      });
  }

  async edit() {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    let data: any = {
      bonus: String(this._contractManager.data.bonus),
      production_bonus: String(this._contractManager.data.production_bonus),
      contract: this._contractManager.data.contract,
      end_date: this._contractManager.data.end_date,
      gross_monthly_12: this._contractManager.data.gross_monthly_12,
      level: this._contractManager.data.level,
      role: this._contractManager.data.role,
      net_monthly_12: this._contractManager.data.net_monthly_12,
      net_monthly_13: this._contractManager.data.net_monthly_13,
      program: this._contractManager.data.program,
      salary_yearly_gross: this._contractManager.data.salary_yearly_gross,
      start_date: this._contractManager.data.start_date,
      ticket_month_number: this._contractManager.data.ticket_month_number,
      ticket_type: this._contractManager.data.ticket_type,
      ticket_value: String(this._contractManager.data.ticket_value),
      total_daily: this._contractManager.data.total_daily,
      total_net_monthly_13: this._contractManager.data.total_net_monthly_13,
      trial: this._contractManager.data.trial,
      tutor_hash: this._contractManager.data.tutor_hash,
    };
    if (this._contractManager.data.contract === 4) {
      //Controllo in caso di contratto a stage elimino campi superflui
      data.bonus = null;
      data.production_bonus = null;
      data.gross_monthly_12 = null;
      data.level = null;
      data.net_monthly_13 = null;
      data.salary_yearly_gross = null;
      data.ticket_month_number = null;
      data.ticket_type = null;
      data.ticket_value = null;
      data.total_net_monthly_13 = null;
      data.trial = null;
    }

    if (!data.end_date || data.end_date.length < 1) {
      data.end_date = null;
    }

    if (data.contract !== 1) {
      // if (data.end_date <= moment(data.start_date).add(data.trial, "days").format("YYYY-MM-DD")) {
      //   await this._utilService.showSWALError({ text: "CONTROL_CONTRACT_DATE" });
      //   return false;
      // }
    }
    this._utilService.showLoading();
    await this._transformationService
      .updateTransformation(Number(this.idTransformation), data)
      .then(async () => {
        if (this.currentTransformation.status_contract != 0) {
          await this._transformationService
            .updateDocumentStatus(Number(this.idTransformation), {
              status: 0,
              type: "contract",
            })
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_TRANSFORMATION" });
              this.currentTransformation.status_contract = 0;
            });
        } else {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_TRANSFORMATION" });
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_UPDATE_TRANSFORMATION" });
      });
  }

  async closeTransformation(idTransformation) {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    // popup
    await this._utilService
      .showSWAL({
        title: "CONFIRM_CLOSE_TRANSFORMATION",
        icon: "warning",
        confirmButtonText: "CONFIRM_BTN",
        customClass: {
          confirmButton: "btn btn-warning",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._transformationService
            .updateTransformationStatus(idTransformation, 1)
            .then(async () => {
              await this.loadTransformation();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_CLOSE_TRANSFORMATION" });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_CLOSE_TRANSFORMATION" }));
        }
      });
  }

  async previewContract(viewFile: boolean = true) {
    this._utilService.showLoading();
    await this._utilService.basic_get(`/collaborator/${this.currentTransformation.user.hash}/contract?force=1`).then(async (response: any) => {
      if (response.contract && viewFile) {
        await this._utilService.getFile(response.contract);
        this.contractPreviewViewed = true;
        this._utilService.hideLoading();
      }
    });
  }

  transformRal(value: any) {
    value = this._utilService.fixRal(value);
    this._contractManager.changeSalaryGrossYearly(value);
  }

  calculateTicketTotalMonth() {
    const ticketValue = this._utilService.removeDotsFromNumber(this._contractManager.data.ticket_value.toString());
    const ticketMonthNumber = this._utilService.removeDotsFromNumber(this._contractManager.data.ticket_month_number.toString());
    return this._utilService.addDotsToNumber(ticketValue * ticketMonthNumber);
  }

  transformTicketValue(target: any) {
    let { value }: any = target;
    if (value.split(",").length > 2) {
      value = value.split(",");
      const decimals: string = value.pop();
      value = value.join(".");
      value += "," + decimals;
    } else if (!value.includes(",")) {
      value += ",00";
    } else {
      value = value.replace(",", ".");
    }

    target.value = value;
    this._contractManager.data.ticket_value = value;
    this._contractManager.updateData();
  }

  async resendMasterData() {
    let confirmationText: string = `${await this._utilService.translate("ALERT.CONFIRM_RESEND_REQUEST_MASTERDATA")}`;
    await this._utilService
      .showSWALDecision({
        text: confirmationText,
        confirmButtonText: "CONFIRM_RESEND_MASTERDATA",
      })
      .then(async (result) => {
        if (result.value) {
          //Vado avanti
          await this.requestDocumentMasterData();
        } else if (result.isDismissed) {
          return false;
        }
      });
  }

  async disableTransformation() {
    this._utilService.showLoading();
    this._modalService.dismissAll();
    await this._transformationService
      .updateTransformationStatus(this.currentTransformation.id, { status: 2, note: this.disableNote })
      .then(async () => {
        await this.loadTransformation();
        this._utilService.hideLoading();
        await this._utilService.showToastrSuccess("SUCCESS_DISABLE_TRANSFORMATION");
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_DISABLE_TRANSFORMATION");
      });
  }

  async restoreTransformation() {
    if (!this._authenticationService.hasCapability("edit_transformation")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    // popup
    await this._utilService
      .showSWAL({
        title: "CONFIRM_RESTORE_TITLE",
        icon: "warning",
        confirmButtonText: "CONFIRM_RESTORE_BTN",
        customClass: {
          confirmButton: "btn btn-success",
        },
      })

      .then(async (result) => {
        if (result.value) {
          await this._transformationService
            .updateTransformationStatus(this.idTransformation, { status: 1, note: null })
            // controllare i testi
            .then(async () => {
              await this.loadTransformation();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_RESTORE_TRANSFORMATION" });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_RESTORE_TRANSFORMATION" }));
        }
      });
  }
}
